<template>
  <!-- 收藏組合取名字 -->
  <div class="modal fade confirm composeNamePopup is-open" v-show="open">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">加入我的收藏組合</h3>
        </div>
        <div class="modal-body px_25">
          <label class="composeNamePopup__inputItem mb_10">
            <span>組合名稱</span>
            <input
              type="text"
              class="form-control form-control-inline mr_5"
              style="width: 250px"
              data-vv-name="composeName"
              v-validate="'required'"
              :class="{
                'is-invalid': errors.has(`composeName`),
              }"
              placeholder="最多輸入二十個字"
              v-model="setgroup_name"
              maxlength="20"
              @input="checkComposeName"
            />
            <span class="composeNamePopup__inputItem--error">必填</span>
          </label>
          <!-- 確定取消按鈕 -->
          <div class="action text-right px_12 mt_10">
            <button
              type="submit"
              class="btn btn-default btn-sm py_5"
              @click.stop="$emit('close')"
            >
              取消
            </button>
            <button
              type="submit"
              class="btn btn-primary btn-sm py_5 ml_10"
              :disabled="!setgroup_name"
              @click.stop="addMyComposeHandler()"
            >
              確定
            </button>
          </div>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
export default {
  props: ["open"],
  mixins: [commonMixin],
  data() {
    return {
      setgroup_name: "",
      loading: false,
    };
  },
  computed: {
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
  },
  methods: {
    async addMyComposeHandler() {
      const checkResult = await this.$validator.validateAll();
      if (checkResult && !this.loading) {
        this.loading = true;
        let toAddMyComposeObj = {
          setgroup_idx: "",
          setgroup_name: this.setgroup_name,
          group_mc_list: [],
        };
        this.MfEditing.mc_prod_list.forEach((mc) => {
          let group_sc_list = [];
          mc.sc_prod_list.forEach((sc) => {
            if (sc.is_checked == "1") {
              group_sc_list.push({
                setsc_idx: "",
                prod_id: sc.prod_id,
              });
            }
          });
          toAddMyComposeObj.group_mc_list.push({
            setmc_idx: "",
            prod_id: mc.prod_id,
            group_sc_list: group_sc_list,
          });
        });
        //呼叫api
        this.$mfAPI
          .MFB0_2000__saveMyGroup(toAddMyComposeObj)
          .then((res) => {
            this.loading = false;
            this.$emit("success");
            this.$toast.info({
              title: "儲存成功!",
            });
            this.setgroup_name = "";
          })
          .catch((error) => {
            this.loading = false;
            this.$emit("close");
            // this.$toast.info({
            //   title: `${error}`,
            // });
            this.setgroup_name = "";

            this.$toast.info({ title: "執行失敗" });
          });
      }
    },
    //檢查組合名稱
    checkComposeName() {
      this.setgroup_name = this.cleanSpecialChar(this.setgroup_name, '@()_');
    },
  },
};
</script>

<style lang="scss" scoped>
.composeNamePopup {
  display: flex;
  flex-direction: column;
  &__inputItem {
    display: flex;
    align-items: center;
    strong {
      display: inline-block;
      width: 20px;
      text-align: center;
    }
    & > span {
      display: inline-block;
      width: 84px;
      font-weight: 700;
    }
    &--error {
      font-size: 13px;
      line-height: 1.69;
      color: #de4054;
      white-space: nowrap;
    }
  }
}
</style>
